import { VisualSwitch } from 'components/VisualSwitch/VisualSwitch'
import { ActiveFlags, FlaggedFeature } from 'hooks/useFlipperFlag'
import { MouseEvent } from 'react'
import Styles from '../FlipperOverrideModal.module.scss'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { CopyFlagsButton } from 'components/FlipperOverrideModal/components/CopyFlagsButton'
import { ResetOverridesButton } from 'components/FlipperOverrideModal/components/ResetOverridesButton'

const FlaggedFeatureItem = observer(({ flag }: { flag: FlaggedFeature }) => {
  const rootStore = useRootStore()
  const featureFlagStore = rootStore.featureFlags
  const isActive = featureFlagStore.isActive(flag)
  const flagOverridden = featureFlagStore.isOverridden(flag)

  const resetFeature = (e: MouseEvent) => {
    e.stopPropagation()
    featureFlagStore.resetFlag(flag)
  }

  return (
    <div className={Styles.feature} onClick={() => featureFlagStore.overrideFlag(flag, !isActive)}>
      <VisualSwitch active={isActive} name={flag} />
      <span className={Styles.flagName}>{flag}</span>
      {flagOverridden && (
        <button className={Styles.resetFeature} onClick={resetFeature}>
          Reset
        </button>
      )}
    </div>
  )
})

export const FlipperOverrideList = () => (
  <div className={Styles.featureContainer}>
    <div className={Styles.buttonContainer}>
      <ResetOverridesButton />
      <CopyFlagsButton />
    </div>
    <div className={Styles.featureList}>
      {ActiveFlags.sort().map((flag) => (
        <FlaggedFeatureItem key={flag} flag={flag} />
      ))}
    </div>
  </div>
)
